import { useGetQuery } from "hooks/useClientPortalQuery";
import { ServiceModel } from "types/generated/models";
import { useAppointmentBookingApi } from "hooks/useAppointmentBookingApi";

interface UseDefaultGroupServiceProps {
    pause?: boolean;
    appointmentId: string | number;
}

export function useDefaultGroupService({ pause, appointmentId }: UseDefaultGroupServiceProps) {
    const { getEndpoint } = useAppointmentBookingApi();

    const { data, isLoading } = useGetQuery<ServiceModel>({
        url: `${getEndpoint("GetDefaultGroupService")}?appointmentId=${appointmentId}`,
        options: { enabled: !pause },
    });

    return {
        defaultGroupService: data,
        isLoading,
    };
}
